// 45be085d06f2b331b038fb65c016444f3a7ecebd|kind=api-js|className=AreaMeasurementUnitApi|type=angular|apiName=am|apiEnumKey=AM|operationHash=4d431867c12a7f2580f7b45429d07aa6adb2b67e

import * as i0 from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Api } from '@myre/common-conf';
import {
  DynamicEnvService,
  AngularSdk,
} from '@myre/ui-domain-http';

import { parseOkResponseWrappingAreaMeasurementUnitListFromJSON } from '../../../parsers/OkResponseWrappingAreaMeasurementUnitList';

export class AreaMeasurementUnitApi extends AngularSdk {
  constructor(
    dynamicEnvService,
    httpClient,
  ) {
    super(dynamicEnvService, httpClient);
  }

  /**
   * @description <p>🔐 Auth</p>
   *
   * @tags AreaMeasurementUnitApi
   * @name AreaMeasurementUnitApiGetAllAreaMeasurementUnits
   * @request GET:/measurements
   * @secure
   */
  getAllAreaMeasurementUnits(
    requestOptions = {},
  ) {
    return this._request(
      {
        path: `/measurements`,
        method: 'GET',
        api: Api.AM,
      },
      {
        ...requestOptions,
        parser: parseOkResponseWrappingAreaMeasurementUnitListFromJSON,
      },
    );
  }

  static ɵfac = function AreaMeasurementUnitApi_Factory(t) { return new (t || AreaMeasurementUnitApi)(i0.inject(DynamicEnvService), i0.inject(HttpClient)); };
  static ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({ token: AreaMeasurementUnitApi, factory: AreaMeasurementUnitApi.ɵfac, providedIn: 'root' });
}
